import React, { useState, useEffect } from 'react';
import { useLocation, Navigate, useNavigate } from 'react-router-dom'
import Cookies from 'universal-cookie';
import '../index.css';
import logo from '../assets/spinner.gif'
import Modal from 'react-modal';
import { performTicketInput, UseLocalStorage, GetAttributesByAssignment, getTicketAttachments, downloadAttachment, addAttachmentToTicket, populateInventoryList } from "../functions";

// Set the app element for react-modal
Modal.setAppElement('#root');

function TicketMaint() {
    const [localStorageAttributes, setLocalStorageAttributes] = UseLocalStorage('attributes', []);

    const navigate = useNavigate();
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [modalText, setModalText] = React.useState("Error saving ticket");
    const [modalType, setModalType] = React.useState("error"); // "success" or "error"

    const [loading, setLoading] = useState(false);

    function openModal(success) {
        console.log('Opening modal with success:', success); // Debug log
        setModalType(success ? "success" : "error");
        setIsOpen(true);
        setTimeout(() => {
            closeModal();
            if (success) {
                navigate('/');
            }
        }, 2200);
    }

    function closeModal() {
        setIsOpen(false);
    }

    const location = useLocation();
    const stateData = location.state;
    let cust;
    let cname;
    let ticket;
    if (stateData) {
        if (stateData.name) {
            cust = stateData;
            cname = cust.name
        }
        if (stateData.orderdate) {
            ticket = stateData;
            cname = ticket.customer;
        }
    }

    const [orderdate, setOrderdate] = useState(ticket ? ticket.orderdate : new Date().toISOString().split('T')[0]);
    const [duedate, setDuedate] = useState(ticket ? ticket.duedate : "");
    const [ticketnumber, setTicketnumber] = useState(ticket ? ticket.id : "");
    const [customername, setCustomername] = useState(cname ? cname : "");
    const [product, setProduct] = useState(ticket ? ticket.product : "");
    const [customProduct, setCustomProduct] = useState("");
    const [isCustomProduct, setIsCustomProduct] = useState(false);
    const [inventoryList, setInventoryList] = useState([]);
    const [price, setPrice] = useState(ticket ? ticket.price : 0);
    const [quantity, setQuantity] = useState(ticket ? ticket.quantity : 1);
    const [shippingfee, setShippingfee] = useState(ticket ? ticket.shippingfee : 0);
    const [otherfees, setOtherfees] = useState(ticket ? ticket.otherfees : 0);
    const [paymentmethod, setPaymentmethod] = useState(ticket ? ticket.paymentmethod : "");
    const [tax, setTax] = useState(ticket ? ticket.tax : 0);
    const [material, setMaterial] = useState(ticket ? ticket.material : 0);
    const [tracking, setTracking] = useState(ticket ? ticket.tracking : "");
    const [ticketstatus, setTicketstatus] = useState(ticket ? ticket.ticketstatus : "pending");
    const [hours, setHours] = useState(ticket && ticket.hours !== undefined ? ticket.hours : "");
    const [notes, setNotes] = useState(ticket ? ticket.notes : "");
    const [attachmentsList, setAttachmentsList] = useState([]);
    const [attachments] = useState(ticket ? ticket.attachments : []);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploadProgress, setUploadProgress] = useState({});
    const [isDragOver, setIsDragOver] = useState(false);

    const ticketAttributes = GetAttributesByAssignment('tickets', localStorageAttributes);
    const ticketTags = ticketAttributes.tags.sort((a, b) => a.displayorder.localeCompare(b.displayorder));
    //setPageTitle(ticketAttributes.displayplural);
    //setPageAttr(ticketAttributes.displayname);
    let pageTitleNew = ticket ? "Update " + ticketAttributes.displayname : "Create " + ticketAttributes.displayname;
    let submitText = ticket ? "Update" : "Create";

    useEffect(() => {
        if (login) {
            const loadPost = async () => {
                setLoading(true);
                
                // Load inventory list
                const inventory = await populateInventoryList();
                setInventoryList(inventory || []);
                
                // Check if existing product is in inventory or custom
                if (ticket && ticket.product) {
                    const inventoryItem = inventory?.find(item => item.item === ticket.product);
                    if (!inventoryItem) {
                        setIsCustomProduct(true);
                        setCustomProduct(ticket.product);
                        setProduct("custom");
                    }
                }
                
                if (attachments && attachments.length > 0) {
                    // Use the new API to get just attachment metadata
                    const attachmentMetadata = await getTicketAttachments(ticket.id);
                    setAttachmentsList(attachmentMetadata);
                }
                setLoading(false);
            };
            loadPost();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleProductChange = (selectedProduct) => {
        if (selectedProduct === "custom") {
            setIsCustomProduct(true);
            setProduct("custom");
            setCustomProduct("");
        } else {
            setIsCustomProduct(false);
            setProduct(selectedProduct);
            setCustomProduct("");
            
            // Find the inventory item and update price
            const inventoryItem = inventoryList.find(item => item.item === selectedProduct);
            if (inventoryItem && inventoryItem.price) {
                setPrice(inventoryItem.price);
            }
        }
    };

    const cookies = new Cookies();
    let login = cookies.get('login');
    if (!login) {
        return (<Navigate to={{ pathname: '../Login' }} />);
    }

    const downloadAttachmentFile = async (attachment) => {
        try {
            setLoading(true);
            // Use the new API to download individual attachment
            const attachmentData = await downloadAttachment(ticket.id, attachment.file_name);
            if (attachmentData) {
                // Create download link
                const link = document.createElement('a');
                link.href = `${attachmentData.file_meta},${attachmentData.base64}`;
                link.download = attachmentData.file_name;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error('Error downloading attachment:', error);
        } finally {
            setLoading(false);
        }
    };

    const getThumbnailSrc = async (attachment) => {
        if (!attachment.is_image) return null;

        try {
            // Use the new API to download the image for thumbnail
            const attachmentData = await downloadAttachment(ticket.id, attachment.file_name);
            if (attachmentData) {
                return `${attachmentData.file_meta},${attachmentData.base64}`;
            }
        } catch (error) {
            console.error('Error loading thumbnail:', error);
        }
        return null;
    };

    const onFileChange = async (event) => {
        const files = Array.from(event.target.files);
        handleFilesSelected(files);
    };

    const handleFilesSelected = (files) => {
        setSelectedFiles(files);

        // Initialize upload progress for each file
        const progress = {};
        files.forEach((file, index) => {
            progress[index] = { name: file.name, progress: 0, status: 'pending' };
        });
        setUploadProgress(progress);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(false);

        const files = Array.from(e.dataTransfer.files);
        handleFilesSelected(files);
    };

    const removeSelectedFile = (index) => {
        const newFiles = selectedFiles.filter((_, i) => i !== index);
        setSelectedFiles(newFiles);

        const newProgress = { ...uploadProgress };
        delete newProgress[index];
        setUploadProgress(newProgress);
    };

    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
        } catch {

        }

        const form = e.target;
        const formData = new FormData(form);
        const formJson = Object.fromEntries(formData.entries());
        
        // Use custom product if selected, otherwise use the selected inventory item
        if (isCustomProduct) {
            formJson.product = customProduct;
        } else {
            formJson.product = product;
        }

        setLoading(true);

        try {
            // First, save the ticket without any files
            const ticketResult = await performTicketInput(formJson);

            if (!ticketResult.hasOwnProperty('id')) {
                setLoading(false);
                openModal(false);
                return;
            }

            const ticketId = ticketResult.id;

            // If there are files to upload, upload them one by one
            if (selectedFiles.length > 0) {
                let successfulUploads = 0;

                for (let i = 0; i < selectedFiles.length; i++) {
                    const file = selectedFiles[i];

                    // Update progress to uploading
                    setUploadProgress(prev => ({
                        ...prev,
                        [i]: { ...prev[i], status: 'uploading', progress: 50 }
                    }));

                    try {
                        const base64Data = await convertFileToBase64(file);

                        // Add attachment to the existing ticket
                        const attachmentResult = await addAttachmentToTicket(ticketId, base64Data, file.name);

                        if (attachmentResult) {
                            // Update progress to completed
                            setUploadProgress(prev => ({
                                ...prev,
                                [i]: { ...prev[i], status: 'completed', progress: 100 }
                            }));
                            successfulUploads++;
                        } else {
                            // Update progress to error
                            setUploadProgress(prev => ({
                                ...prev,
                                [i]: { ...prev[i], status: 'error', progress: 0 }
                            }));
                        }
                    } catch (error) {
                        console.error('Error uploading file:', file.name, error);
                        setUploadProgress(prev => ({
                            ...prev,
                            [i]: { ...prev[i], status: 'error', progress: 0 }
                        }));
                    }
                }

                setLoading(false);

                if (successfulUploads === selectedFiles.length) {
                    setModalText(`Ticket ${ticketId} saved with ${successfulUploads} attachments!`);
                } else if (successfulUploads > 0) {
                    setModalText(`Ticket ${ticketId} saved with ${successfulUploads}/${selectedFiles.length} attachments uploaded successfully.`);
                } else {
                    setModalText(`Ticket ${ticketId} saved, but no attachments were uploaded successfully.`);
                }
                openModal(true);
            } else {
                // No files to upload
                setLoading(false);
                setModalText('Ticket ' + ticketResult.id + ' saved successfully!');
                console.log('About to open success modal'); // Debug log
                openModal(true);
            }
        } catch (error) {
            console.error('Error saving ticket:', error);
            setLoading(false);
            openModal(false);
        }
    };

    const tagID = ticketTags.find(item => item.tag === 'id');
    const tagOrderDate = ticketTags.find(item => item.tag === 'orderdate');
    const tagDueDate = ticketTags.find(item => item.tag === 'duedate');
    const tagCustomer = ticketTags.find(item => item.tag === 'customer');
    const tagProduct = ticketTags.find(item => item.tag === 'product');
    const tagPrice = ticketTags.find(item => item.tag === 'price');
    const tagQuantity = ticketTags.find(item => item.tag === 'quantity');
    const tagPaymentMethod = ticketTags.find(item => item.tag === 'paymentmethod');
    const tagShipping = ticketTags.find(item => item.tag === 'shipping');
    const tagOtherfees = ticketTags.find(item => item.tag === 'otherfees');
    const tagTax = ticketTags.find(item => item.tag === 'tax');
    const tagMaterial = ticketTags.find(item => item.tag === 'material');
    const tagTracking = ticketTags.find(item => item.tag === 'tracking');
    const tagStatus = ticketTags.find(item => item.tag === 'ticketstatus');
    const tagHours = ticketTags.find(item => item.tag === 'hours');
    const tagNotes = ticketTags.find(item => item.tag === 'notes');

    return (
        <>
            <div className="TicketMaint">
                <h1>{pageTitleNew}</h1>

                {/* Success/Error Modal */}
                {modalIsOpen && (
                    <div className="custom-modal-overlay" onClick={closeModal}>
                        <div
                            className={`custom-modal ${modalType === "success" ? "success" : "error"}`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="modal-icon">
                                {modalType === "success" ? (
                                    <div className="checkmark-circle">
                                        <div className="checkmark"></div>
                                    </div>
                                ) : (
                                    <div className="error-circle">
                                        <div className="error-x"></div>
                                    </div>
                                )}
                            </div>
                            <h2 className="modal-title">
                                {modalType === "success" ? "Success!" : "Error!"}
                            </h2>
                            <p className="modal-message">{modalText}</p>
                            <div className="modal-progress-bar">
                                <div className="modal-progress-fill"></div>
                            </div>
                            {modalType === "success" && (
                                <p className="modal-redirect-text">Redirecting to home...</p>
                            )}
                        </div>
                    </div>
                )}

                <div className="ticket-form-container">
                    <form onSubmit={handleSubmit} className="ticket-form">
                        <div className="form-section">
                            <h3>Ticket Information</h3>

                            {/* Basic Info Row */}
                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="ticketnumber">{tagID.displayname}</label>
                                    <input
                                        type="text"
                                        name="ticketnumber"
                                        value={ticketnumber}
                                        onChange={(e) => setTicketnumber(e.target.value)}
                                        readOnly
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="orderdate">{tagOrderDate.displayname}</label>
                                    <input
                                        type="date"
                                        name="orderdate"
                                        value={orderdate}
                                        onChange={(e) => setOrderdate(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>

                            {/* Due Date and Customer Row */}
                            <div className="form-row">
                                {tagCustomer.enabled === 'true' && (
                                    <div className="form-group">
                                        <label htmlFor="customername">{tagCustomer.displayname}</label>
                                        <input
                                            type="text"
                                            name="customername"
                                            value={customername}
                                            onChange={(e) => setCustomername(e.target.value)}
                                            required
                                            readOnly
                                        />
                                    </div>
                                )}
                                {tagDueDate && tagDueDate.enabled === 'true' && (
                                    <div className="form-group">
                                        <label htmlFor="duedate">{tagDueDate.displayname}</label>
                                        <input
                                            type="date"
                                            name="duedate"
                                            value={duedate}
                                            onChange={(e) => setDuedate(e.target.value)}
                                        />
                                    </div>
                                )}
                            </div>

                            {/* Product Row */}
                            <div className="form-row">
                                {tagProduct.enabled === 'true' && (
                                    <div className="form-group">
                                        <label htmlFor="product">{tagProduct.displayname}</label>
                                        <select
                                            name="product"
                                            value={product}
                                            onChange={(e) => handleProductChange(e.target.value)}
                                            required
                                            style={{ flex: '1' }}
                                        >
                                            <option value="">Select a product...</option>
                                            {inventoryList.map((item) => (
                                                <option key={item.item} value={item.item}>
                                                    {item.item} {item.price ? `- $${item.price}` : ''}
                                                </option>
                                            ))}
                                            <option value="custom">Custom</option>
                                        </select>
                                        {isCustomProduct && (
                                            <input
                                                type="text"
                                                name="customProduct"
                                                value={customProduct}
                                                onChange={(e) => setCustomProduct(e.target.value)}
                                                placeholder="Enter custom product name"
                                                required
                                                style={{ flex: '1' }}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* Pricing Row */}
                            {(tagPrice.enabled === 'true' || tagQuantity.enabled === 'true' || tagShipping.enabled === 'true') && (
                                <div className="form-row">
                                    {tagPrice.enabled === 'true' && (
                                        <div className="form-group">
                                            <label htmlFor="price">{tagPrice.displayname}</label>
                                            <input
                                                type="number"
                                                name="price"
                                                value={price}
                                                min="0"
                                                step="0.01"
                                                onChange={(e) => setPrice(e.target.value)}
                                                required
                                            />
                                        </div>
                                    )}
                                    {tagQuantity.enabled === 'true' && (
                                        <div className="form-group">
                                            <label htmlFor="quantity">{tagQuantity.displayname}</label>
                                            <input
                                                type="number"
                                                name="quantity"
                                                value={quantity}
                                                min="1"
                                                onChange={(e) => setQuantity(e.target.value)}
                                                required
                                            />
                                        </div>
                                    )}
                                    {tagShipping.enabled === 'true' && (
                                        <div className="form-group">
                                            <label htmlFor="shippingfee">{tagShipping.displayname}</label>
                                            <input
                                                type="number"
                                                name="shippingfee"
                                                value={shippingfee}
                                                min="0"
                                                step="0.01"
                                                onChange={(e) => setShippingfee(e.target.value)}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Status, Payment & Other Fees Row */}
                            {(tagPaymentMethod.enabled === 'true' || tagStatus.enabled === 'true' || tagOtherfees.enabled === 'true') && (
                                <div className="form-row">
                                    {tagStatus.enabled === 'true' && (
                                        <div className="form-group">
                                            <label htmlFor="ticketstatus">{tagStatus.displayname}</label>
                                            <select
                                                name="ticketstatus"
                                                value={ticketstatus}
                                                onChange={(e) => setTicketstatus(e.target.value)}
                                            >
                                                <option value="pending">Pending</option>
                                                <option value="cancelled">Cancelled</option>
                                                <option value="inprogress">In Progress</option>
                                                <option value="completed">Completed</option>
                                            </select>
                                        </div>
                                    )}
                                    {tagPaymentMethod.enabled === 'true' && (
                                        <div className="form-group">
                                            <label htmlFor="paymentmethod">{tagPaymentMethod.displayname}</label>
                                            <input
                                                type="text"
                                                name="paymentmethod"
                                                value={paymentmethod}
                                                onChange={(e) => setPaymentmethod(e.target.value)}
                                            />
                                        </div>
                                    )}
                                    {tagOtherfees.enabled === 'true' && (
                                        <div className="form-group">
                                            <label htmlFor="otherfees">{tagOtherfees.displayname}</label>
                                            <input
                                                type="number"
                                                name="otherfees"
                                                value={otherfees}
                                                min="0"
                                                step="0.01"
                                                onChange={(e) => setOtherfees(e.target.value)}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Hours, Material and Tax Row */}
                            {(tagHours.enabled === 'true' || tagMaterial.enabled === 'true' || tagTax.enabled === 'true') && (
                                <div className="form-row">
                                    {tagHours.enabled === 'true' && (
                                        <div className="form-group">
                                            <label htmlFor="hours">{tagHours ? tagHours.displayname : 'Hours'}</label>
                                            <input
                                                type="number"
                                                name="hours"
                                                value={hours}
                                                min="0"
                                                step="0.1"
                                                onChange={(e) => setHours(e.target.value)}
                                            />
                                        </div>
                                    )}
                                    {tagMaterial.enabled === 'true' && (
                                        <div className="form-group">
                                            <label htmlFor="material">{tagMaterial.displayname}</label>
                                            <input
                                                type="number"
                                                name="material"
                                                value={material}
                                                min="0"
                                                step="0.01"
                                                onChange={(e) => setMaterial(e.target.value)}
                                            />
                                        </div>
                                    )}
                                    {tagTax.enabled === 'true' && (
                                        <div className="form-group">
                                            <label htmlFor="tax">{tagTax.displayname}</label>
                                            <input
                                                type="number"
                                                name="tax"
                                                value={tax}
                                                min="0"
                                                step="0.01"
                                                onChange={(e) => setTax(e.target.value)}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Tracking Row */}
                            {tagTracking.enabled === 'true' && (
                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="tracking">{tagTracking.displayname}</label>
                                        <input
                                            type="text"
                                            name="tracking"
                                            value={tracking}
                                            onChange={(e) => setTracking(e.target.value)}
                                        />
                                    </div>
                                </div>
                            )}

                            {/* Notes */}
                            {tagNotes.enabled === 'true' && (
                                <div className="form-row">
                                    <div className="form-group full-width">
                                        <label htmlFor="notes">{tagNotes.displayname}</label>
                                        <textarea
                                            name="notes"
                                            value={notes}
                                            onChange={(e) => setNotes(e.target.value)}
                                            rows={4}
                                        />
                                    </div>
                                </div>
                            )}

                            {/* File Upload */}
                            <div className="form-row">
                                <div className="form-group full-width">
                                    <label htmlFor="formfile">Attachments</label>
                                    <div
                                        className={`drag-drop-area ${isDragOver ? 'drag-over' : ''}`}
                                        onDragOver={handleDragOver}
                                        onDragLeave={handleDragLeave}
                                        onDrop={handleDrop}
                                        onClick={() => document.getElementById('formfile').click()}
                                    >
                                        <div className="drag-drop-content">
                                            <div className="drag-drop-icon">📁</div>
                                            <div className="drag-drop-text">
                                                <strong>Drop files here</strong> or <span className="click-text">click to browse</span>
                                            </div>
                                            <div className="drag-drop-help">
                                                You can select or drop multiple files at once
                                            </div>
                                        </div>
                                    </div>
                                    <input
                                        id="formfile"
                                        type="file"
                                        name="formfile"
                                        onChange={onFileChange}
                                        multiple
                                        accept="*/*"
                                        style={{ display: 'none' }}
                                    />
                                </div>
                            </div>

                            <div className="form-submit">
                                <button type="submit" disabled={loading}>
                                    {loading ? 'Saving...' : submitText}
                                </button>
                            </div>
                        </div>
                    </form>

                    {/* Selected Files Preview */}
                    {selectedFiles.length > 0 && (
                        <div className="selected-files-section">
                            <div className="selected-files-list">
                                <h3>
                                    Selected Files ({selectedFiles.length})
                                    {Object.values(uploadProgress).filter(p => p.status === 'completed').length > 0 && (
                                        <span className="upload-summary">
                                            {' '}- {Object.values(uploadProgress).filter(p => p.status === 'completed').length}/{selectedFiles.length} uploaded
                                        </span>
                                    )}
                                </h3>
                                <div className="selected-files-grid">
                                    {selectedFiles.map((file, index) => (
                                        <SelectedFileItem
                                            key={index}
                                            file={file}
                                            index={index}
                                            progress={uploadProgress[index]}
                                            onRemove={() => removeSelectedFile(index)}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Current Attachments */}
                    {(attachmentsList.length > 0 || loading) && (
                        <div className="current-attachments-section">
                            <div className="attachments-list">
                                <h3>Current Attachments</h3>
                                {loading ? (
                                    <div className="loading-container">
                                        <img src={logo} style={{ width: '30px' }} alt="loading..." />
                                    </div>
                                ) : (
                                    <div className="attachments-grid">
                                        {attachmentsList.map((attachment, index) => (
                                            <AttachmentItem
                                                key={index}
                                                attachment={attachment}
                                                onDownload={() => downloadAttachmentFile(attachment)}
                                                getThumbnailSrc={getThumbnailSrc}
                                            />
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );

}

function SelectedFileItem({ file, index, progress, onRemove }) {
    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();
        switch (extension) {
            case 'pdf':
                return '📄';
            case 'doc':
            case 'docx':
                return '📝';
            case 'xls':
            case 'xlsx':
                return '📊';
            case 'zip':
            case 'rar':
                return '🗜️';
            case 'txt':
                return '📃';
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
                return '🖼️';
            default:
                return '📎';
        }
    };

    const formatFileSize = (bytes) => {
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'completed': return '#4CAF50';
            case 'uploading': return '#2196F3';
            case 'error': return '#f44336';
            default: return '#e0a54c';
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case 'completed': return 'Uploaded';
            case 'uploading': return 'Uploading...';
            case 'error': return 'Error';
            default: return 'Ready';
        }
    };

    return (
        <div className="selected-file-item">
            <div className="file-icon-small">
                {getFileIcon(file.name)}
            </div>
            <div className="file-details">
                <div className="file-name" title={file.name}>
                    {file.name}
                </div>
                <div className="file-size">
                    {formatFileSize(file.size)}
                </div>
                {progress && (
                    <div className="upload-status">
                        <span style={{ color: getStatusColor(progress.status) }}>
                            {getStatusText(progress.status)}
                        </span>
                        {progress.status === 'uploading' && (
                            <div className="progress-bar">
                                <div
                                    className="progress-fill"
                                    style={{ width: `${progress.progress}%` }}
                                ></div>
                            </div>
                        )}
                    </div>
                )}
            </div>
            {(!progress || progress.status === 'pending') && (
                <button
                    type="button"
                    className="remove-file-btn"
                    onClick={onRemove}
                    title="Remove file"
                >
                    ✕
                </button>
            )}
        </div>
    );
}

function AttachmentItem({ attachment, onDownload, getThumbnailSrc }) {
    const [thumbnailSrc, setThumbnailSrc] = useState(null);
    const [loadingThumbnail, setLoadingThumbnail] = useState(false);

    const loadThumbnail = async () => {
        if (attachment.is_image) {
            setLoadingThumbnail(true);
            const src = await getThumbnailSrc(attachment);
            setThumbnailSrc(src);
            setLoadingThumbnail(false);
        }
    };

    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();
        switch (extension) {
            case 'pdf':
                return '📄';
            case 'doc':
            case 'docx':
                return '📝';
            case 'xls':
            case 'xlsx':
                return '📊';
            case 'zip':
            case 'rar':
                return '🗜️';
            case 'txt':
                return '📃';
            default:
                return '📎';
        }
    };

    const formatFileSize = (bytes) => {
        if (bytes === 0) return 'Unknown size';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    return (
        <div className="attachment-item">
            <div className="attachment-preview">
                {attachment.is_image ? (
                    <div className="image-preview">
                        {!thumbnailSrc && !loadingThumbnail && (
                            <button
                                className="load-thumbnail-btn"
                                onClick={loadThumbnail}
                            >
                                🖼️ Load Preview
                            </button>
                        )}
                        {loadingThumbnail && (
                            <div className="thumbnail-loading">Loading...</div>
                        )}
                        {thumbnailSrc && (
                            <img
                                src={thumbnailSrc}
                                alt={attachment.file_name}
                                className="attachment-thumbnail"
                            />
                        )}
                    </div>
                ) : (
                    <div className="file-icon">
                        {getFileIcon(attachment.file_name)}
                    </div>
                )}
            </div>
            <div className="attachment-info">
                <div className="attachment-name" title={attachment.file_name}>
                    {attachment.file_name}
                </div>
                <div className="attachment-size">
                    {formatFileSize(attachment.file_size)}
                </div>
                <button
                    className="download-btn"
                    onClick={onDownload}
                >
                    ⬇️ Download
                </button>
            </div>
        </div>
    );
}

export default TicketMaint;
